import { createMongoAbility } from '@casl/ability';
import { createContextualCan, useAbility } from '@casl/react';
import { createContext } from 'react';

import type { MongoAbility } from '@casl/ability';

export const AbilityContext = createContext<MongoAbility>(createMongoAbility([]));

/**
 * Returns the ability object for the current user. NOTE: This ability object is subject to being overridden by the
 * "View as user" feature.
 *
 * This hook uses CASL's `useAbility` hook which subscribes to the ability's internal event emitter, ensuring components
 * re-render when rules change imperatively. (For the record, we don't -- this is just for completeness)
 */
export function useAbilityContext(): MongoAbility {
	return useAbility(AbilityContext);
}

export const Can = createContextualCan(AbilityContext.Consumer);

export const AbilityWithoutOverrideContext = createContext<MongoAbility>(createMongoAbility([]));

export function useAbilityWithoutOverrideContext(): MongoAbility {
	return useAbility(AbilityWithoutOverrideContext);
}
